<div
  class="tw-relative tw-z-10 {{ showModal ? 'tw-visible' : 'tw-hidden' }}"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <!--
  Background backdrop, show/hide based on modal state.

  Entering: "ease-out duration-300"
  From: "opacity-0"
  To: "opacity-100"
  Leaving: "ease-in duration-200"
  From: "opacity-100"
  To: "opacity-0"
  -->
  <div
    class="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity"
  ></div>

  <div class="tw-fixed tw-inset-0 tw-z-10 tw-w-screen tw-overflow-y-auto">
    <div
      class="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0"
      id="modal"
    >
      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
      From: "opacity-100 translate-y-0 sm:scale-100"
      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div
        class="tw-relative tw-transform tw-overflow-hidden tw-rounded-md tw-bg-white tw-text-left tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full {{
          small ? 'sm:tw-max-w-xl' : 'sm:tw-max-w-3xl'
        }} {{ size }}"
      >
        <div class="tw-bg-white">
          <div class="sm:tw-flex sm:tw-items-start">
            <div
              class="tw-mt-3 sm:tw-mt-0 sm:tw-text-left tw-text-center tw-w-full"
            >
              <!-- header -->
              <div
                class="tw-flex tw-items-center tw-justify-between tw-px-3 tw-pb-4 tw-pt-5 sm:tw-p-4 sm:tw-pb-4t"
              >
                <h3
                  class="tw-text-sm tw-font-semibold tw-leading-6 tw-text-gray-900 tw-uppercase"
                  id="modal-title"
                >
                  {{ title }}
                </h3>
                <span
                  class="{{
                    !!closeText ? 'tw-text-base' : 'material-icons'
                  }} tw-text-blue-800 tw-text-[24px] cursor-pointer"
                  (click)="closeModal.emit()"
                  >{{ !!closeText ? closeText : 'close' }}</span
                >
              </div>
              <hr />

              <!-- errors messages -->
              @if (errorMessage !== '') {
                <div
                  class="tw-p-4 tw-bg-rose-200 tw-justify-start tw-items-center tw-gap-2 tw-inline-flex tw-w-full"
                >
                  <div
                    class="tw-grow tw-shrink tw-basis-0 tw-justify-start tw-items-center tw-gap-4 tw-flex"
                  >
                    <div class="material-icons tw-text-[18px] tw-text-red-700">
                      error_outline
                    </div>
                    <div class="tw-text-red-700 tw-text-sm tw-font-semibold">
                      {{ errorMessage }}
                    </div>
                  </div>
                </div>
              }

              <!-- modal content -->
              <div
                class="tw-mt-2 tw-px-3 tw-pb-4 tw-pt-5 sm:tw-p-4 sm:tw-pb-4t"
              >
                <p class="tw-text-base tw-text-gray-500">
                  @if ((content | typeof) === 'object') {
                    <ng-container [ngTemplateOutlet]="content"></ng-container>
                  } @else {
                    {{ content }}
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tw-bg-gray-50 tw-px-4 tw-py-3 sm:tw-flex sm:tw-flex-row-reverse sm:tw-px-6 tw-items-center tw-gap-3"
        >
          @if (hasContinueControl) {
            <cohrex-button
              (click)="continue.emit()"
              [loading]="loading"
              [disabled]="disabled"
              [color]="$safeNavigationMigration(control?.color)"
              >{{
                $safeNavigationMigration(control?.name) | translate
              }}</cohrex-button
            >
          }
          @if (hasCancelControl) {
            <cohrex-button color="primaryLink" (click)="closeModal.emit()">{{
              cancelText | translate
            }}</cohrex-button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
